<div class="content">
  <div class="api-reference-body position-relative">
    <router-outlet></router-outlet>
  </div>
</div>

